import { render, staticRenderFns } from "./ServicesPayments.vue?vue&type=template&id=6e94d7d8&"
import script from "./ServicesPayments.vue?vue&type=script&lang=js&"
export * from "./ServicesPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports